import React from 'react';

import Grid from '@material-ui/core/Grid';

import CategoriesDashboard from '../../components/CategoriesDashboard';
import withBreadcrumbs from '../App/HOCs/withBreadcrumbs';

const HomePage = () => (
	<Grid container direction="column" alignItems="center" component="section" style={{ marginTop: -20 }}>
		<Grid item container xs={12} sm={12} md={12} lg={11} xl={10}>
			<CategoriesDashboard />
		</Grid>
	</Grid>
);

export default withBreadcrumbs(HomePage);
